import { Grid, SxProps, Theme, Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { NumberTextField } from 'shared/controls';
import { Expense, Brands } from 'shared/types';
import { buildFieldExpenseNameWithIndex } from 'shared/utility';
import { ExpenseTypeDropdown } from './expense-type-dropdown';

const rootStyles: SxProps<Theme> = {
  width: '100%',
  position: 'relative',
};

interface ExpenseCardProps {
  expense: Expense;
  editMode: boolean;
  index: number;
}
export function ExpenseCard({ expense, editMode, index }: ExpenseCardProps) {
  const buildFieldName = buildFieldExpenseNameWithIndex<Expense>(index);
  const { setValue } = useFormContext();
  const { brand } = useParams<{ brand: Brands }>();
  const isNianticBrand: boolean = brand === 'nianticseal';

  const quantityChange = (quantity: number) => {
    const extendedPrice = Number(expense.price) * quantity;
    setValue(buildFieldName('extendedPrice'), extendedPrice);
  };

  const priceChange = (price: number) => {
    const extendedPrice = Number(expense.quantity) * price;
    setValue(buildFieldName('extendedPrice'), extendedPrice);
  };

  return (
    <Box sx={rootStyles}>
      <Grid item xs container spacing={6}>
        <Grid item xs={12} lg>
          <ExpenseTypeDropdown name={buildFieldName('type')} defaultValue={expense.type} disabled={!editMode} />
        </Grid>
        <Grid item xs={12} lg>
          {editMode ? (
            <NumberTextField
              label='Quantity'
              name={buildFieldName('quantity')}
              defaultValue={Number(expense.quantity)}
              onChangeValue={quantityChange}
            />
          ) : (
            <NumberTextField
              label='Quantity'
              name={buildFieldName('quantity')}
              defaultValue={Number(expense.quantity)}
              disabled
            />
          )}
        </Grid>
        <Grid item xs={12} lg>
          {editMode ? (
            <NumberTextField
              label='Price'
              name={buildFieldName('price')}
              defaultValue={Number(expense.price)}
              prefix='$'
              fixedDecimalScale
              decimalScale={isNianticBrand ? 4 : 2}
              onChangeValue={priceChange}
            />
          ) : (
            <NumberTextField
              label='Price'
              name={buildFieldName('price')}
              defaultValue={Number(expense.price)}
              decimalScale={isNianticBrand ? 4 : 2}
              prefix='$'
              fixedDecimalScale
              disabled
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
